import { __extends } from "tslib";
import { GetBaiduChannelRequest, GetBaiduChannelResponse } from "../models/models_0";
import { deserializeAws_restJson1GetBaiduChannelCommand, serializeAws_restJson1GetBaiduChannelCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetBaiduChannelCommand = /** @class */ (function (_super) {
    __extends(GetBaiduChannelCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetBaiduChannelCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetBaiduChannelCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "PinpointClient";
        var commandName = "GetBaiduChannelCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: GetBaiduChannelRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetBaiduChannelResponse.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetBaiduChannelCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1GetBaiduChannelCommand(input, context);
    };
    GetBaiduChannelCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1GetBaiduChannelCommand(output, context);
    };
    return GetBaiduChannelCommand;
}($Command));
export { GetBaiduChannelCommand };
//# sourceMappingURL=GetBaiduChannelCommand.js.map